import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { maybeAsyncToObservable } from './maybe-async-to-observable.util';
import { catchError, forkJoin, map, Observable, of, take } from 'rxjs';
import { inject } from '@angular/core';

export const mergeResolvers = <T>(
  resolve: {
    [key in keyof T]: ResolveFn<T[key]>;
  },
  redirectUrl = 'not-found'
): ResolveFn<{ [key: string]: unknown }> => {
  return (route, state) => {
    const _route = inject(Router);
    const redirectCommand = new RedirectCommand(_route.parseUrl(redirectUrl));

    const sources = Object.entries<ResolveFn<unknown>>(resolve).reduce(
      (acc, [key, resolver]) => {
        acc[key] = maybeAsyncToObservable(resolver(route, state));
        return acc;
      },
      {} as { [key: string]: Observable<unknown> }
    );

    return forkJoin(sources).pipe(
      take(1),
      map(results => {
        const isRedirect = Object.values(results).some(
          value => value instanceof RedirectCommand
        );
        if (isRedirect) {
          return redirectCommand;
        }
        return results;
      }),
      catchError(() => of(redirectCommand))
    );
  };
};
